<template>
  <div class="worder-top">
    <div class="worder-title" @click="handleCancel">
      <a-icon class="icon" type="left" />返回
    </div>
  </div>
</template>

<script>


  export default {
    name: 'BackTab',
    methods:{
      handleCancel(){
        this.$emit("cancel");
      }
    }
  }
</script>
<style lang="less" scoped>
.worder-top{
  background: #193C63;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  padding: 12px 24px;
}
.worder-title{
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}
.worder-title .icon{
  width: 16px;
  height: 12px;
  margin-right: 6px;
  margin-top: -5px;
}
</style>